$(document).ready(function(){
  const showSearchBar = document.querySelector('#btnSearchAction');
  const searchBar = document.querySelector('#searchBar');
  
  $(showSearchBar).click(function() {
    $(showSearchBar).toggleClass('active');
    $(searchBar).toggleClass('active');
  });
});

$(document).ready(function(){
  const showPanel = document.querySelector('#btnOpenPanel');
  const showPanel1 = document.querySelector('#btnOpenPanel1');
  const panel = document.querySelector('#panelContainer');
  
  //$(showPanel).click(function() {
  //  $(this).toggleClass('active');
  //  $(panel).toggleClass('active');
  //  $('body').toggleClass('overflowScrollNone');
  //});
  $(showPanel1).click(function() {
    $(this).toggleClass('open');
    if($(panel).hasClass('active')){
      $(panel).fadeOut(300).toggleClass('active');
    } else {
      $(panel).fadeIn(300).toggleClass('active');
    }
    $('body').toggleClass('overflowScrollNone');
  });
  $(panel).click(function() {
    //$(showPanel).toggleClass('active');
    $(showPanel1).toggleClass('open');
    if($(panel).hasClass('active')){
      $(panel).fadeOut(300).toggleClass('active');
    } else {
      $(panel).fadeIn(300).toggleClass('active');
    }
    $('body').toggleClass('overflowScrollNone');
  });
});

$(document).ready(function(){
  const slider = document.querySelector('#slider-text');
  const sidebar = document.querySelector('#sidebar');
  
  const resizeObserver = new ResizeObserver(entries => {
    if($('div').find(slider)){
      //console.log('Slider height changed:', entries[0].target.clientHeight);
      sidebar.setAttribute("style","top :" + entries[0].target.clientHeight + "px");
    }
  })

  if (window.location.href === "https://www.koimagazine.fr/" || window.location.href.indexOf("blogs/nos-articles/") > -1 && window.location.href != "https://www.koimagazine.fr/blogs/nos-articles/" || window.location.href === "https://www.koimagazine.fr/#") {
    resizeObserver.observe(slider)
  }
});